import { ModalDialog, ModalMessage, ModalMessageColorsEnum } from '@acceso/design-system';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CheckboxForm, TCheckboxFormProps } from './CheckboxForm';

export function CheckboxConfirmation<T extends FieldValues>({
  form,
  ...otherProps
}: Omit<TCheckboxFormProps<T>, 'mapChange'>) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const onConfirmation = () => {
    // @ts-ignore
    form.setValue('parameters.enrichments.stt', true);
    // @ts-ignore
    form.setValue('parameters.enrichments.advertising', true);
  };

  return (
    <>
      <CheckboxForm
        {...otherProps}
        form={form}
        mapChange={(onChange, event) => {
          if (
            // @ts-ignore
            !form.getValues('parameters.enrichments.stt') &&
            event.currentTarget.value === 'false'
          ) {
            setOpen(true);
            return;
          }

          onChange(event);
        }}
      />

      {createPortal(
        <ModalDialog
          isOpen={open}
          onClose={() => setOpen(false)}
          onAction={onConfirmation}
          heading={t('Activar cortes automáticos')}
          actionLabel={t('Confirmar')}
          linkLabel={t('Cancelar')}
          color={ModalMessageColorsEnum.WARNING}
          parentClassName="z-[250]"
        >
          <ModalMessage
            title={t('Esta acción también activará la transcripción de texto. ¿Deseas continuar?')}
          />
        </ModalDialog>,
        document.body
      )}
    </>
  );
}
